import UploadTask from './UploadTask';

export default UploadTask;
